import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-audience-settings',
  templateUrl: './audience-settings.component.html',
  styleUrls: ['./audience-settings.component.scss']
})
export class AudienceSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
